import React from 'react';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log detallado para diagnóstico en consola del navegador
    // y para herramientas remotas si existieran
    try {
      // eslint-disable-next-line no-console
      console.error('[UI ErrorBoundary] Capturado error:', error, errorInfo);
    } catch (_) {}
    this.setState({ errorInfo });
  }

  render() {
    if (this.state.hasError) {
      const { error, errorInfo } = this.state;
      return (
        <div className="max-w-4xl mx-auto my-4">
          <div className="bg-white rounded-lg shadow border border-yellow-300">
            <div className="flex items-center gap-2 px-4 py-3 border-b bg-yellow-50">
              <span className="font-semibold text-yellow-800">Aviso</span>
              <span className="text-yellow-800">Se produjo un error al renderizar la interfaz.</span>
            </div>
            <div className="px-4 pt-3 text-sm text-gray-700">
              {String(error?.message || 'Error desconocido')}
            </div>
            <div className="px-4 pb-3 flex gap-3">
              <button type="button" onClick={() => window.location.reload()} className="bg-yellow-500 hover:bg-yellow-600 text-white px-3 py-2 rounded">
                Recargar
              </button>
              <button type="button" onClick={() => { try { window.location.assign('/'); } catch (_) {} }} className="bg-gray-600 hover:bg-gray-700 text-white px-3 py-2 rounded">
                Ir al inicio
              </button>
            </div>
            <div className="px-4 py-3 bg-gray-50 border-t">
              <div className="text-sm font-medium text-gray-600 mb-2">Detalles técnicos</div>
              {error?.stack && (
                <pre className="whitespace-pre-wrap text-xs text-gray-700 mb-2">{String(error.stack)}</pre>
              )}
              {errorInfo?.componentStack && (
                <pre className="whitespace-pre-wrap text-xs text-gray-700">{String(errorInfo.componentStack)}</pre>
              )}
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
